import React from 'react';

const AccessWrapper = props => {
  const { hasAccess, fallback = null, children } = props;
  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default AccessWrapper;
